module.exports = __webpack_public_path__ + "img/2-2.64225dc8.png";